// Copyright 2022 Sorama B.V.

import { ICamConnectionInfo } from "services/Hardware/CamHTTP/ICamConnectionInfo";

export class CamIV64ConnectionInfo implements ICamConnectionInfo {
    public readonly domain = "sorama-iv64.local";
    public readonly username = "admin";
    public readonly password = "admin";
    public readonly port = "9013";
}
